import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { filterRowDisplayStyles } from "@faire/retailer-visitor-shared/components/Filters/filterRowDisplayStyles";
import { ScrollWrapper } from "@faire/retailer-visitor-shared/components/Scroll/ScrollWrapper";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { commonStylesForHideTopNav, inlineTransitionStylesForHideTopNav } from "@faire/retailer-visitor-shared/navbar/styles";
import { useStickyNavContentPositions } from "@faire/retailer-visitor-shared/navbar/useStickyNavContentPositions";
import { useSettingNavSearchUX } from "@faire/retailer-visitor-shared/settings/useSettingNavSearchUX";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { useIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useRef, useState } from "react";
import styled, { css } from "styled-components";
//When the dragging distance is less than 10, the carousel will not scroll, but instead, consider as a click event.
var DRAGGABLE_THRESHOLD = 10;
export var MaybeDraggableStickyRowForDiscoverPage = function(param) {
    var children = param.children, className = param.className, isLoading = param.isLoading, overflowVisible = param.overflowVisible, setIsDragging = param.setIsDragging;
    var isLoggedOutDiscover = useIsLoggedOutDiscoverPage();
    var heightWithHeaderOrMarketBanner = useTopOfPageContent().heightWithHeaderOrMarketBanner;
    var shouldRetainOriginalPosition = useStickyNavContentPositions(isLoading).shouldRetainOriginalPosition;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _useSettingNavSearchUX = useSettingNavSearchUX(), isNavSearchUX = _useSettingNavSearchUX.isTreatment;
    var isMobile = useViewport().isMobile;
    var stickyContentRef = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isMouseDown = _useState[0], setIsMouseDown = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), mouseDownRelativeXCoordinate = _useState1[0], setMouseDownRelativeXCoordinate = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), scrollLeft = _useState2[0], setScrollLeft = _useState2[1];
    var handleMouseDown = function(isDown) {
        setIsMouseDown(isDown);
    };
    var onMouseDown = function(event) {
        var currentElement = stickyContentRef.current;
        if (!currentElement) {
            return;
        }
        handleMouseDown(true);
        var x = currentElement.getBoundingClientRect().x;
        // record starting x coordinate relative to carousel
        setMouseDownRelativeXCoordinate(event.pageX - x);
        setScrollLeft(currentElement.scrollLeft);
    };
    var onMouseMove = function(event) {
        var _currentElement_scrollTo;
        if (!isMouseDown) {
            return;
        }
        var currentElement = stickyContentRef.current;
        if (!currentElement || mouseDownRelativeXCoordinate === undefined || scrollLeft === undefined) {
            return;
        }
        event.preventDefault();
        var x = currentElement.getBoundingClientRect().x;
        // calculate mouse x coordinate relative to the carousel
        var mouseRelativeXCoordinate = event.pageX - x;
        // calculate distance mouse moved
        var movingDistance = mouseRelativeXCoordinate - mouseDownRelativeXCoordinate;
        if (Math.abs(movingDistance) < DRAGGABLE_THRESHOLD) {
            return;
        }
        // scroll carousel based on the distance mouse moved
        setIsDragging(true);
        (_currentElement_scrollTo = currentElement.scrollTo) === null || _currentElement_scrollTo === void 0 ? void 0 : _currentElement_scrollTo.call(currentElement, {
            left: scrollLeft - movingDistance
        });
    };
    if (isLoggedOutDiscover) {
        return /*#__PURE__*/ _jsx(DiscoverStickyRow, {
            ref: stickyContentRef,
            className: className,
            $top: heightWithHeaderOrMarketBanner,
            style: inlineTransitionStylesForHideTopNav(shouldRetainOriginalPosition, heightWithHeaderOrMarketBanner),
            $isLoggedOut: !isLoggedInRetailer,
            onMouseDown: onMouseDown,
            onMouseLeave: function() {
                return handleMouseDown(false);
            },
            onMouseUp: function() {
                handleMouseDown(false);
                setIsDragging(false);
            },
            onMouseMove: onMouseMove,
            $disableSticky: isNavSearchUX && isMobile,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(StickyRow, {
        ref: stickyContentRef,
        className: className,
        $top: heightWithHeaderOrMarketBanner,
        style: inlineTransitionStylesForHideTopNav(shouldRetainOriginalPosition, heightWithHeaderOrMarketBanner),
        $isLoggedOut: !isLoggedInRetailer,
        $overflowVisible: overflowVisible,
        children: children
    });
};
var StickyRow = styled.div.withConfig({
    componentId: "sc-1592741b-0"
})([
    "position:sticky;top:",
    "px;",
    ";-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}left:0;z-index:10;background-color:",
    ";&:empty{display:none;}",
    "{",
    " padding:",
    ";margin:",
    ";}",
    " ",
    ""
], function(param) {
    var $top = param.$top;
    return $top !== null && $top !== void 0 ? $top : 0;
}, function(param) {
    var $overflowVisible = param.$overflowVisible;
    return $overflowVisible ? css([
        "overflow:unset;"
    ]) : css([
        "overflow-x:auto;"
    ]);
}, Core.surface.inverse, responsiveMediaQueries.tabletAndBelow, function(param) {
    var $isLoggedOut = param.$isLoggedOut;
    return !$isLoggedOut ? css([
        "width:100vw;"
    ]) : null;
}, getSpacing(0, "2x"), getSpacing(0, "-2x"), commonStylesForHideTopNav, filterRowDisplayStyles);
var DiscoverStickyRow = styled(ScrollWrapper).withConfig({
    componentId: "sc-1592741b-1"
})([
    "position:",
    ";top:",
    "px;overflow-x:auto;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}left:0;z-index:10;background-color:",
    ";&:empty{display:none;}&:hover{cursor:grab;}&:active{cursor:grabbing;}",
    "{",
    " padding:",
    ";margin:",
    ";}",
    " ",
    ""
], function(param) {
    var $disableSticky = param.$disableSticky;
    return $disableSticky ? "static" : "sticky";
}, function(param) {
    var $top = param.$top;
    return $top !== null && $top !== void 0 ? $top : 0;
}, Core.surface.inverse, responsiveMediaQueries.tabletAndBelow, function(param) {
    var $isLoggedOut = param.$isLoggedOut;
    return !$isLoggedOut ? css([
        "width:100vw;"
    ]) : null;
}, getSpacing(0, "2x"), getSpacing(0, "-2x"), commonStylesForHideTopNav, filterRowDisplayStyles);
